const initKnowDoctorStep = () => {
    const knowDoctorSectionStep = document.querySelector("[data-know-doctor-section-step]");
    if (knowDoctorSectionStep) {
        const radioButtonList = knowDoctorSectionStep.querySelectorAll("[data-radio-button]");
        if (radioButtonList && radioButtonList.length > 0) {
            const containerToShow = knowDoctorSectionStep.querySelector("[data-show]");
            const searchDoctorInput = containerToShow.querySelector("[data-search-doctor]");
            const searchDoctorBtn = containerToShow.querySelector("[data-search-btn]");
            const performanceId = new URL(window.location.href).searchParams.get("performanceId");
            const doctorId = new URL(window.location.href).searchParams.get("doctorId");
            const venueId = new URL(window.location.href).searchParams.get("venueId");
            const doctorsContainerToAppend = document.querySelector("[data-doctors-section]");
            const doctorsAfterVenueToAppend = document.querySelector("[data-doctors-after-venue]");
            const venueListContainerToAppend = document.querySelector("[data-venue-list-section]");
            const dataSearchDoctor = document.getElementById("doctorName");
            //const contactFormToAppend: HTMLElement = document.querySelector("[data-contact-form]");
            const contactFormToAppend = document.querySelector("[data-contact-form-step]");
            if (doctorId || (doctorId && venueId)) {
                containerToShow.setAttribute("data-show", "show");
                doctorsContainerToAppend.setAttribute("data-show", "show");
                venueListContainerToAppend.setAttribute("data-show", "show");
            }
            else if (venueId) {
                doctorsContainerToAppend.setAttribute("data-show", "hidden");
                venueListContainerToAppend.setAttribute("data-show", "show");
                doctorsAfterVenueToAppend.setAttribute("data-show", "show");
                initDoctorSelectorDuplex();
            }
            radioButtonList.forEach((radioButton) => {
                if (doctorId) {
                    if (radioButton.value == "true") {
                        radioButton.checked = true;
                    }
                }
                else if (venueId) {
                    if (radioButton.value == "false") {
                        radioButton.checked = true;
                    }
                }
                radioButton.addEventListener("click", () => {
                    if (radioButton.value == "true") {
                        const urlSearchParams = new URLSearchParams(window.location.search);
                        urlSearchParams.delete("venueId");
                        const updatedUrl = `${window.location.pathname}?${urlSearchParams}`;
                        window.history.replaceState({}, document.title, updatedUrl);
                        dataSearchDoctor.value = "";
                        containerToShow.setAttribute("data-show", "show");
                        doctorsContainerToAppend.setAttribute("data-show", "hidden");
                        venueListContainerToAppend.setAttribute("data-show", "hidden");
                        doctorsAfterVenueToAppend.setAttribute("data-show", "hidden");
                        contactFormToAppend.setAttribute("data-show", "hidden");
                    }
                    else {
                        // remove the "doctorId" parameter from the URL
                        const urlSearchParams = new URLSearchParams(window.location.search);
                        urlSearchParams.delete("doctorId");
                        const updatedUrl = `${window.location.pathname}?${urlSearchParams}`;
                        window.history.replaceState({}, document.title, updatedUrl);
                        containerToShow.setAttribute("data-show", "hidden");
                        doctorsContainerToAppend.setAttribute("data-show", "hidden");
                        venueListContainerToAppend.setAttribute("data-show", "show");
                        contactFormToAppend.setAttribute("data-show", "hidden");
                        updateUrlParams(venueListContainerToAppend, `/GetVenue?performanceId=${performanceId}&stepId=2`, null, null, initVenueSelector);
                    }
                });
            });
            if (searchDoctorBtn && searchDoctorInput) {
                searchDoctorBtn.addEventListener("click", () => {
                    updateUrlParams(doctorsContainerToAppend, `/GetDoctors?performanceId=${performanceId}&src=${searchDoctorInput.value}`, null, null, initDoctorSelector, initToggler);
                    doctorsContainerToAppend.setAttribute("data-show", "show");
                });
                searchDoctorInput.addEventListener("keydown", (e) => {
                    if (e.key === "Enter") {
                        searchDoctorBtn.click();
                    }
                });
            }
        }
    }
};
